<template>
  <v-dialog :value="true" max-width="500px" persistent>
    <v-card text>
      <v-container grid-list-xl fluid>
        <v-card-title>
          <span class="headline">{{ $t("new_graveyard") }}</span>
        </v-card-title>

        <v-layout wrap>
          <v-flex xs12 class="py-0">
            <v-text-field
              v-model="graveyardName"
              :label="$t('name')"
              :rules="[nameRule]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('cancel')">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          :disabled="!isNewGraveyardValid()"
          @click="$emit('createGraveyard', graveyardName)"
        >
          {{ $t("create") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NewGraveyardDialog",
  props: {},
  data() {
    return {
      graveyardName: "",
      nameRule: (value) => {
        const pattern = /^[a-zA-Z][a-zA-Z0-9]{2,}$/;
        return pattern.test(value) || this.$t("error.graveyard_rule");
      },
    };
  },
  methods: {
    isNewGraveyardValid() {
      const pattern = /^[a-zA-Z][a-zA-Z0-9]{2,}$/;
      return pattern.test(this.graveyardName);
    },
  },
};
</script>
